import React from 'react';

function SummaryTranscript({ summaryData }) {
    console.log(summaryData);
    return (
        <div className="summaryTranscriptContent custom-scrollbars">
            <table>
                <tbody>
                {summaryData && summaryData["narrative summary"] && (
                    <tr>
                        <td colSpan="2">
                            <titlep>Narrative Summary</titlep>
                            <ul className="narrative-summary-list">
                                {summaryData["narrative summary"].map((item, index) => (
                                    <li key={`narrative-${index}`}>{item["narrative sentence"]}</li>
                                    ))}
                            </ul>
                        </td>
                    </tr>
                )}

                {summaryData && summaryData["key information"] && summaryData["key information"].map((item, index) => (
                    <tr key={`key-info-${index}`}>
                        <td className="title">{item.name}</td>
                        <td>{item.information}</td>
                    </tr>
                ))}

                </tbody>
            </table>
        </div>
    );
}

export default SummaryTranscript;
